import { FrameworkReducers } from "./FrameworkReducer.js";
import { GameReducers } from "./GameReducer.js";
import { UiReducers } from "./UiReducer.js";

/**
 * @type {{string: function(SwucState, string=): SwucState}}
 */
let _reducers = {
  initState: (state) => state,
};

/**
 * @name registerReducer
 * @param {{string: function(SwucState, string=): SwucState}} newReducer
 */
export function registerReducer(newReducer) {
  _reducers = { ..._reducers, ...newReducer };
}

/**
 * @name getReducers
 * @description Get the reducers
 * @return {{string: function(SwucState, string=): SwucState}}
 */
export function getReducers() {
  return { ..._reducers };
}

export function initReducers() {
  registerReducer(FrameworkReducers);
  registerReducer(GameReducers);
  registerReducer(UiReducers);
}
